<template>
<CRow>
    <CCol col="12" sm="12" class="mx-auto">
        <Form :submit="submit" :campaign="$deepClone(campaign)" ref="campaignForm" />
    </CCol>
</CRow>
</template>

<script>
import { mapActions } from 'vuex'
import Form from './partials/Form'
import { StoreStatus } from '@/constants'

export default {
    name: 'Create',

    components: {
        Form
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            // vm.fetchMediaTypes(),
            vm.fetchStores({
                no_paginate: true,
                status: [StoreStatus.ACTIVE]
            })
        })
    },

    data() {
        return {
            campaign: {
                store_id: this.$currentUser().store.id || null,
                goal: null,
                name: '',
                // started_at: '',
                // finished_at: '',
                description: '',
                // targeting: {
                //     logical_operator: 'and',
                //     children: {
                //         [CampaignTarget.PUBLISHER_MEDIA_TYPE]: {
                //             id: Math.floor(Math.random() * Date.now()),
                //             key: CampaignTarget.PUBLISHER_MEDIA_TYPE,
                //             values: {}
                //         }
                //     }
                // },
                plan: {
                    id: '',
                    settings: {},
                    key: '',
                },
            }
        }
    },

    methods: {
        ...mapActions({
            create: 'campaign/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            fetchStores: 'store/fetch',
            // fetchUsers: 'user/fetch',
            // fetchMediaTypes: 'campaign/fetchMediaTypes',
        }),
        submit(campaign) {
            const campaignForm = this.$refs.campaignForm
            this.setShowLoading()
            this.resetMsg()

            this.create(campaign).then(() => {
                this.$router.push({name: 'campaigns'})
            }).catch(result => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
        // users() {
        //     if (!this.$policy('campaign').create_any_or_group) {
        //         return
        //     }

        //     this.fetchUsers({
        //         no_paginate: true,
        //         role: {
        //             accesses: ['campaign.manage_own']
        //         }
        //     })
        // },
    }
}
</script>
